(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-review-carousel]').forEach((root) => {
    const track = root.querySelector('[data-review-track]');
    const cards = [...root.querySelectorAll('[data-review-card]')];
    const prev = root.querySelector('[data-review-prev]');
    const next = root.querySelector('[data-review-next]');
    if (!track || cards.length < 2) return;
    const step = () => cards[0].getBoundingClientRect().width + 22;
    const move = (dir) => track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    let stoppedByUser = false;
    const stopPermanently = () => { stoppedByUser = true; clearInterval(timer); };
    prev?.addEventListener('click', () => { stopPermanently(); move(-1); });
    next?.addEventListener('click', () => { stopPermanently(); move(1); });
    let timer;
    const start = () => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      clearInterval(timer);
      timer = setInterval(() => {
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 10;
        track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step(), behavior: 'smooth' });
      }, 6500);
    };
    // Pause only while the pointer is directly over the review carousel itself.
    // Moving elsewhere in the section does not affect autoplay. Clicking/touching
    // or using the keyboard remains an intentional interaction and stops autoplay.
    track.addEventListener('mouseenter', () => clearInterval(timer));
    track.addEventListener('mouseleave', () => { if (!stoppedByUser) start(); });
    track.addEventListener('pointerdown', stopPermanently);
    track.addEventListener('keydown', stopPermanently);
    start();
  });
});

  } catch(e) { console.error(e); }
})();
})();
